<template>
    <div class="cookie" v-if="shouldShowBanner">
        <div class="wrapper">
            <div class="cookie__wrapper">
                <div class="cookie__content">
                    <slot></slot>
                </div>
                <div class="cookie__aside">
                    <div @click="hideBanner">
                        <slot name="button"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

import {useCookieMessage} from "../composables/useCookieMessage";

const {shouldShowBanner,hideBanner} = useCookieMessage();



</script>
